/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Directory_Models_Last_UpdatedInputs */

const en_directory_models_last_updated = /** @type {(inputs: Directory_Models_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last updated: ${i?.date}`)
};

const zh_directory_models_last_updated = /** @type {(inputs: Directory_Models_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`更新时间：${i?.date}`)
};

/**
* | output |
* | --- |
* | "Last updated: {date}" |
*
* @param {Directory_Models_Last_UpdatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_models_last_updated = /** @type {((inputs: Directory_Models_Last_UpdatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Models_Last_UpdatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_models_last_updated(inputs)
	return zh_directory_models_last_updated(inputs)
});
export { directory_models_last_updated as "directory.models.last_updated" }